import { useMemo } from 'react'

import { selectContentGenerationStatus } from '~publish/legacy/ai/state/slice'
import { useIsIntegrationUploading } from '~publish/legacy/integrations-bar/state/useIsIntegrationUploading'
import { useAppSelector } from '~publish/legacy/store'
import { selectIsAnyUploading } from '~publish/legacy/uploads/state/selectors'

import { getFormattedWhatPreventsSavingMessages } from './buttons/utils'
import AppStore from '../../stores/AppStore'

export const UPLOAD_IN_PROGRESS_MESSAGE = 'Please wait for uploads to finish'

export function usePostValidation(): {
  isSavePostDisabled: boolean
  isSaveDraftDisabled: boolean
  postValidationIssues: Array<React.ReactElement | string> | null
  draftValidationIssues: Array<React.ReactElement | string> | null
} {
  const {
    whatPreventsSaving,
    whatPreventsSavingDraft,
    isSavingDraftPossible,
    isSavingPossible,
  } = AppStore.getAppState()

  const { contentGenerationInProgress } = useAppSelector((state) =>
    selectContentGenerationStatus(state),
  )

  const isMediaUploading = useAppSelector(selectIsAnyUploading)
  const { isIntegrationUploading } = useIsIntegrationUploading()
  const areUploadsInProgress = isMediaUploading || isIntegrationUploading

  return useMemo(() => {
    if (areUploadsInProgress) {
      return {
        isSavePostDisabled: true,
        isSaveDraftDisabled: true,
        postValidationIssues: [UPLOAD_IN_PROGRESS_MESSAGE],
        draftValidationIssues: [UPLOAD_IN_PROGRESS_MESSAGE],
      }
    }

    const postValidationIssues = contentGenerationInProgress
      ? ['Generating content...']
      : getFormattedWhatPreventsSavingMessages({
          warningMessages: whatPreventsSaving,
        })

    const draftValidationIssues = contentGenerationInProgress
      ? ['Generating content...']
      : getFormattedWhatPreventsSavingMessages({
          warningMessages: whatPreventsSavingDraft,
        })

    return {
      isSavePostDisabled: !isSavingPossible,
      isSaveDraftDisabled: !isSavingDraftPossible,
      postValidationIssues,
      draftValidationIssues,
    }
  }, [
    areUploadsInProgress,
    contentGenerationInProgress,
    whatPreventsSavingDraft,
    whatPreventsSaving,
    isSavingPossible,
    isSavingDraftPossible,
  ])
}
